module.exports = __webpack_public_path__ + "static/media/create_details.35130f49.png";